module.exports = __webpack_public_path__ + "img/created-by-user-icon.c5bb2599.svg";